module.exports = __webpack_public_path__ + "static/media/ToyotaType-Semibold.63415d8b.otf";